<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";

export default {
  mixins: [fandomBasicMixin]
};
</script>

<template>
  <div v-easyadmin="easyadminId" class="pt-3" :style="{'background-color': content.background_color}" :class="contentType" stripe-ambassador>
    <div class="container px-3 px-sm-0 py-3 py-md-4">
      <div class="row mx-0 justify-content-center">
        <div class="col-12">
          <tile-ambassador class="w-100" :content="content" :opt-container-content="containerContent"></tile-ambassador>
          <div v-if="content.description" class="mt-4 text-center font-lg" v-html="content.description"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[stripe-ambassador] {
  .h3 {
    font-size: $h2-font-size;
  }
  .social-icons {
    margin-top: 1.5rem;
  }
}
</style>
